import { t } from '@lingui/macro';
import { ICellRendererParams } from 'ag-grid-community';
import { Tooltip } from 'components/Tooltip/Tooltip';
import applicationCellStyles from '../ApplicationStatusCell/ApplicationStatusCell.module.css';
import styles from './ProductTypeCell.module.css';

interface CellRendererParams {
  value: string;
  crossSellProduct: boolean;
}

export const ProductTypeCell = ({
  value: productType,
  crossSellProduct,
}: Omit<ICellRendererParams, 'value'> & CellRendererParams) => {
  const renderProductType = () => {
    return (
      <div className={styles.productList}>
        {productType.split(',').map((product, i) => (
          <span key={`${product}-${i}`} className={styles.product}>
            {product}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div
      className={applicationCellStyles.applicationStatusContainer}
      data-testid="product-type-cell"
    >
      {renderProductType()}
      {crossSellProduct && (
        <Tooltip
          id="product-type"
          value={t`A Recovery Loan was requested but we offered a Flexi-Loan`}
        />
      )}
    </div>
  );
};
